export default "__VITE_ASSET__C3NVdx75__"